var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gantt-elastic",staticStyle:{"width":"100%"}},[_vm._t("header"),_c('main-view',{ref:"mainView"}),_vm._t("footer")],2)}
var staticRenderFns = []

export { render, staticRenderFns }